import { Injectable, Component, Input, NgModule, ComponentRef, ViewContainerRef, Compiler, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';

import { LoggerService } from './logger.service';
import { SharedModule } from './../components/common/shared.module';
import { DynamicComponentModule } from './../components/pg-renderer/item-body/item-body-panel/dynamic-component-module';
import { HtmlService } from './html.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Injectable()
export class DynamicComponentService {

    constructor(
        private loggerService: LoggerService,
        private compiler: Compiler,
        private htmlService: HtmlService
    ) {
    }

    private createNewComponent(template: string) {
        @Component({
            selector: 'dummy-place-holder',
            template: template,
        })
        class CustomDynamicComponent implements OnDestroy {
            @Input() interactions: PgRendererDto.InteractionDefinition[];
            @Input() itemBodyPanel: PgRendererDto.ItemBodyPanel;

            ngOnDestroy() {
                console.log('ngOnDestroy');
            }

            getInteraction(interactionRefNum: number): PgRendererDto.InteractionDefinition {
                return this.interactions.find(x => x.InteractionRefNum == interactionRefNum);
            }
        };
        return CustomDynamicComponent;
    }

    private createComponentModule(componentType: any) {
        @NgModule({
            imports: [
                SharedModule,
                DynamicComponentModule
            ],
            declarations: [componentType],
        })
        class RuntimeComponentModule {
        }
        // a module for just this Type
        return RuntimeComponentModule;
    }

    getComponentRef(viewContainerRef: ViewContainerRef, srcHtml: string): Promise<ComponentRef<any>> {
        return new Promise((resolve, reject) => {
            const html = this.htmlService.replaceAllPlaceHolders(srcHtml);
            const type = this.createNewComponent(html);
            const module = this.createComponentModule(type);
            this.compiler
                .compileModuleAndAllComponentsAsync(module)
                .then((moduleWithFactories) => {
                    const factory = _.find(moduleWithFactories.componentFactories, { componentType: type });
                    resolve(viewContainerRef.createComponent(factory, 0));
                });
        });
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/dynamic-component.service.ts